module.exports = __webpack_public_path__ + "img/dunyue.1143ee7a.png";